import enChangePin from './changePin.i18n.json';

export const changePin = {
  en: enChangePin,
};
